import { render, staticRenderFns } from "./ContactBanner.vue?vue&type=template&id=a0fe2876&scoped=true"
import script from "./ContactBanner.vue?vue&type=script&lang=js"
export * from "./ContactBanner.vue?vue&type=script&lang=js"
import style0 from "./ContactBanner.vue?vue&type=style&index=0&id=a0fe2876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe2876",
  null
  
)

export default component.exports